/* Verolae · Comparison Table
   Port of the source site "ceylon_comparison_table" CTA behaviour. The source button had an inline
   onclick:
     var el = document.querySelector('.shopify-payment-button__button,[data-product-form],.product-form');
     if (el) el.closest('section,[data-section-id]')?.scrollIntoView({behavior:'smooth',block:'center'})
   The port renders the CTA as a link (URL setting). When "Scroll to the product form" is enabled and the
   page contains a buy box, the click smooth-scrolls to that section exactly like the source; on pages
   without one the link is simply followed. Dependency-free; guards against multiple instances;
   re-initialises on theme-editor section load. */
(function () {
  'use strict';

  var BUY_BOX_SELECTOR = '.shopify-payment-button__button,[data-product-form],.product-form';

  function scrollToProductForm() {
    var el = document.querySelector(BUY_BOX_SELECTOR);
    if (!el || typeof el.closest !== 'function') return false;
    var target = el.closest('section,[data-section-id]');
    if (!target) return false;
    target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    return true;
  }

  function initSection(root) {
    if (!root || root.getAttribute('data-verolae-comparison-init') === 'true') return;
    root.setAttribute('data-verolae-comparison-init', 'true');

    var cta = root.querySelector('.pct__cta-btn');
    if (cta && cta.getAttribute('data-scroll-to-product') === 'true') {
      cta.addEventListener('click', function (event) {
        if (scrollToProductForm()) event.preventDefault();
      });
    }
  }

  function initAll(scope) {
    var nodes = (scope || document).querySelectorAll('.pct[data-verolae-comparison-table]');
    Array.prototype.forEach.call(nodes, initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  /* Theme editor: (re)initialise a freshly (re)rendered section */
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
